const layoutStyles = {
  root: {
    display: "flex",
    backgroundColor: "#f8f7fa",
    minHeight: "100dvh",
  },

  drawer: (isBelowMd, drawerWidth) => ({
    width: isBelowMd ? "auto" : drawerWidth,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: drawerWidth,
      boxSizing: "border-box",
      padding: isBelowMd ? "14px 8px 16px 24px" : "34px 16px 0px 16px",
      boxShadow: "0px 2px 8px 0px #2F2B3D1F",
      borderTopRightRadius: isBelowMd ? "20px" : "0px",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
  }),

  closeButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },

  closeIcon: {
    color: "rgba(62, 63, 76, 1)",
    fontSize: "20px",
  },

  sidebarContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

  sidebarHeader: {
    px: "8px",
  },

  sidebarTitle: {
    color: "rgba(62, 63, 76, 0.7)",
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "uppercase",
  },

  logoContainer: {
    mt: "24px",
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },

  logoText: {
    color: "rgba(62, 63, 76, 1)",
    fontSize: 14,
    fontWeight: 400,
  },

  menuItemsContainer: {
    mt: "32px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: 1,
  },

  menuItem: (isActive) => ({
    display: "flex",
    gap: "8px",
    alignItems: "center",
    py: "10px",
    pl: "8px",
    pr: "4px",
    borderRadius: "8px",
    backgroundColor: isActive ? "rgba(245, 246, 250, 1)" : "transparent",
    "&:hover": {
      backgroundColor: "rgba(245, 246, 250, 1)",
    },
  }),

  menuItemText: {
    fontSize: "15px",
    fontWeight: 400,
    whiteSpace: "nowrap",
    flex: "unset",
    m: "0px",
    color: "rgba(62, 63, 76, 1)",
  },

  bottomNavContainer: {
    mt: "22px",
    mb: 2,
  },

  mainContent: (drawerOpen, drawerWidth, theme) => ({
    flexGrow: 1,
    bgcolor: "#f8f7fa",
    width: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)`,
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(!drawerOpen && {
      width: `calc(100% - ${theme.spacing(7)})`,
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${theme.spacing(9)})`,
      },
    }),
  }),

  mainContentBox: (isBelowMd) => ({
    overflow: "auto",
    flexGrow: 1,
    flexBasis: 0,
    display: "flex",
    flexDirection: "column",
    p: isBelowMd ? "8px" : "28px 24px 24px 24px",
  }),

  pageTitleBox: (isBelowMd) => ({
    display: isBelowMd ? "none" : "flex",
    justifyContent: "space-between",
    gap: "8px",
  }),

  pageTitleTextBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  pageTitleStyle: {
    color: "rgba(62, 63, 76, 0.9)",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "28px",
  },

  contentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  communityDropdown: {
    button: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      gap: "12px",
      paddingX: "6px",
      paddingY: "5px",
      borderRadius: "50px",
      border: "none",
      ":hover": { backgroundColor: "rgba(255, 255, 255, 1)" },
    },
    text: {
      whiteSpace: "normal",
      fontSize: { xs: "13px", md: "14px" },
      fontWeight: 500,
      lineHeight: "100%",
      color: "rgba(47, 43, 61, 0.9)",
    },
    menuPaper: {
      minWidth: "max-content",
      padding: "4px",
      marginTop: "4px",
    },
    menuItem: {
      padding: "6px 8px",
      borderRadius: "6px",
      ":hover": {
        backgroundColor: "rgb(241, 245, 249)",
      },
      "&.Mui-selected": {
        backgroundColor: "rgb(241, 245, 249)",
        ":hover": {
          backgroundColor: "rgb(241, 245, 249)",
        },
      },
    },
    menuItemText: {
      lineHeight: "100%",
      fontSize: { xs: "13px", md: "14px" },
      fontWeight: 500,
    },
  },

  // Static twin of `communityDropdown.button` — used when the user manages a
  // single community, so there is nothing to switch to and no arrow is shown.
  communityPill: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "100%",
    minHeight: "48px",
    boxSizing: "border-box",
    paddingX: "6px",
    paddingY: "5px",
    borderRadius: "50px",
    backgroundColor: "rgba(255, 255, 255, 1)",
  },

  communityPillText: {
    flexGrow: 1,
    textAlign: "left",
    whiteSpace: "normal",
    fontSize: { xs: "13px", md: "14px" },
    fontWeight: 500,
    lineHeight: "100%",
    color: "rgba(47, 43, 61, 0.9)",
  },
};

const soonBadge = {
  background: "rgba(36, 139, 112, 0.15)",
  height: "15px",
  width: "34px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "12px",
  color: "rgba(36, 139, 112, 0.8)",
  fontSize: "10px",
  fontWeight: 500,
};

const previewBadge = {
  background: "rgba(235, 150, 96, 0.15)",
  height: "15px",
  padding: "4px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  borderRadius: "12px",
  color: "rgba(223, 131, 80, 1)",
  opacity: 0.8,
  fontSize: "10px",
  fontWeight: 500,
};

export { layoutStyles, soonBadge, previewBadge };
